export enum ScorecardMilestoneActionDisplayType {
  segment = 0,
  value = 1,
}
